import { ApiResponse } from 'apisauce';
import { create } from 'zustand';
import { myNetworkPageRepository } from './myNetworkPage.repository';

export type Count = {
  RECEIVED: number;
  SENT: number;
  SUGGESTIONS: number;
};

const initialCount: Count = {
  RECEIVED: 0,
  SENT: 0,
  SUGGESTIONS: 0,
};

interface MyNetworkState {
  count: Count;
  getNotificationUpdate: () => Promise<void>;
  reset: () => void;
}

export const useMyNetworkStore = create<MyNetworkState>((set) => ({
  count: initialCount,

  getNotificationUpdate: async () => {
    const response: ApiResponse<Count> = await myNetworkPageRepository().getCount();
    if (response.ok) {
      set({ count: response.data || initialCount });
    }
  },

  reset: () => {
    set({ count: initialCount });
  },
}));

const myNetworkStore = {
  get count() {
    return useMyNetworkStore.getState().count;
  },
  getNotificationUpdate: () => useMyNetworkStore.getState().getNotificationUpdate(),
  reset: () => useMyNetworkStore.getState().reset(),
};

export default myNetworkStore;
